import { useState, useEffect } from 'react';
import { History, ArrowRight } from 'lucide-react';
import api from '../../lib/api';

const ACTIONS = {
    assigned: { el: 'Ανάθεση', en: 'Assigned', cls: 'bg-green-100 text-green-700' },
    moved: { el: 'Μεταφορά', en: 'Moved', cls: 'bg-blue-100 text-blue-700' },
    unassigned: { el: 'Αφαίρεση', en: 'Removed', cls: 'bg-slate-200 text-slate-600' },
};

export const AssignmentLogCard = ({ el, refreshKey = 0 }) => {
    const [items, setItems] = useState(null);

    useEffect(() => {
        api.get('/leasing/assignment-log').then((r) => setItems(r.data)).catch(() => setItems(null));
    }, [refreshKey]);

    if (!items) return null;
    const loc = el ? 'el-GR' : 'en-GB';

    return (
        <div className="fleet-card p-5 space-y-3" data-testid="assignment-log-card">
            <div className="flex items-center gap-2">
                <History className="w-5 h-5 text-slate-500" />
                <h2 className="text-base md:text-lg font-semibold text-slate-800">{el ? 'Ιστορικό αναθέσεων' : 'Assignment history'}</h2>
            </div>
            {items.length ? (
                <div className="max-h-80 overflow-y-auto">
                    <table className="w-full text-sm">
                        <tbody>
                            {items.map((l) => {
                                const a = ACTIONS[l.action] || ACTIONS.assigned;
                                return (
                                    <tr key={l.id} className="border-t border-slate-100" data-testid={`assignment-log-${l.id}`}>
                                        <td className="py-2 pr-3 text-xs text-slate-500 whitespace-nowrap">{new Date(l.at).toLocaleString(loc, { dateStyle: 'short', timeStyle: 'short' })}</td>
                                        <td className="py-2 pr-3"><span className={`text-xs px-2 py-0.5 rounded ${a.cls}`}>{el ? a.el : a.en}</span></td>
                                        <td className="py-2 pr-3 font-medium text-slate-800">{l.client_name}</td>
                                        <td className="py-2 pr-3 text-slate-600">
                                            <span className="inline-flex items-center gap-1">{l.from_manager?.name || '-'}<ArrowRight className="w-3 h-3" />{l.to_manager?.name || '-'}</span>
                                        </td>
                                        <td className="py-2 text-xs text-slate-400">{el ? 'από' : 'by'} {l.by?.name}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : <p className="text-sm text-slate-400" data-testid="assignment-log-empty">{el ? 'Δεν υπάρχουν καταγραφές ακόμα.' : 'No entries yet.'}</p>}
        </div>
    );
};
